import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { NmiConfig } from '../nmi.config';
import { CreateInvoiceRequest, Invoice, InvoiceEvent } from '../models/nmi.models';

export class NmiInvoiceService {
  private readonly base: string;

  constructor(private http: HttpClient, config: NmiConfig) {
    this.base = config.apiUrl.replace(/\/$/, '');
  }

  create(req: CreateInvoiceRequest): Observable<Invoice> {
    return this.http.post<Invoice>(`${this.base}/api/invoices`, req);
  }

  get(id: number): Observable<Invoice> {
    return this.http.get<Invoice>(`${this.base}/api/invoices/${id}`);
  }

  getByCustomer(customerId: string): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(`${this.base}/api/invoices/customer/${customerId}`);
  }

  getByStatus(status: string): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(`${this.base}/api/invoices/status/${status}`);
  }

  void(id: number): Observable<Invoice> {
    return this.http.post<Invoice>(`${this.base}/api/invoices/${id}/void`, {});
  }

  markPaid(id: number): Observable<Invoice> {
    return this.http.post<Invoice>(`${this.base}/api/invoices/${id}/mark-paid`, {});
  }

  getEvents(id: number): Observable<InvoiceEvent[]> {
    return this.http.get<InvoiceEvent[]>(`${this.base}/api/invoices/${id}/events`);
  }
}
